import React, { useContext } from 'react';
import { useTranslation } from 'next-i18next';
import { formatPoints } from './utils/price.js';
import { CoreContext } from './context/index.js';
import { selectShowPoints } from './store/points/pointsSlice.js';
import { useRouter } from 'next/router';

const Prices = ({ show, prices, points, pointsRange, className = '', isVariant = false, hasPointsDisclaimer = false, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const { t } = useTranslation('', { keyPrefix: '' });
    const { useSelector } = useContext(CoreContext);
    const showPoints = useSelector(selectShowPoints);
    const router = useRouter();
    const locale = router.locale;
    if (!show)
        return null;
    const parsePrice = (price) => {
        const match = price.match(/(\d[\d\s,.]*)/);
        return match ? parseFloat(match[1].replace(/[^\d,]/g, '').replace(',', '.')) : null;
    };
    const oldPriceFirstRange = (_a = prices.oldPrice) === null || _a === void 0 ? void 0 : _a.split(' - ')[0];
    const newPriceFirstRange = (_b = prices.newPrice) === null || _b === void 0 ? void 0 : _b.split(' - ')[0];
    const oldPriceFirstNumber = parsePrice(oldPriceFirstRange);
    const newPriceFirstNumber = parsePrice(newPriceFirstRange);
    const shouldDisplayOldPrice = prices.oldPrice &&
        prices.oldPrice !== prices.newPrice &&
        ((prices.oldPrice.includes(' - ') && prices.newPrice.includes(' - ')) ||
            (!prices.oldPrice.includes(' - ') && !prices.newPrice.includes(' - '))) &&
        oldPriceFirstNumber !== newPriceFirstNumber;
    const shouldDisplayOldPoints = ((_c = pointsRange === null || pointsRange === void 0 ? void 0 : pointsRange.minimum_price) === null || _c === void 0 ? void 0 : _c.final_price) !== ((_d = pointsRange === null || pointsRange === void 0 ? void 0 : pointsRange.minimum_price) === null || _d === void 0 ? void 0 : _d.regular_price) &&
        ((_e = pointsRange === null || pointsRange === void 0 ? void 0 : pointsRange.maximum_price) === null || _e === void 0 ? void 0 : _e.final_price) !== ((_f = pointsRange === null || pointsRange === void 0 ? void 0 : pointsRange.maximum_price) === null || _f === void 0 ? void 0 : _f.regular_price);
    const showPointsRange = pointsRange &&
        !isVariant &&
        ((_g = pointsRange === null || pointsRange === void 0 ? void 0 : pointsRange.minimum_price) === null || _g === void 0 ? void 0 : _g.final_price) !== ((_h = pointsRange === null || pointsRange === void 0 ? void 0 : pointsRange.maximum_price) === null || _h === void 0 ? void 0 : _h.final_price);
    const rawPointsValue = points !== null && points !== void 0 ? points : (((_j = pointsRange === null || pointsRange === void 0 ? void 0 : pointsRange.minimum_price) === null || _j === void 0 ? void 0 : _j.final_price) != null &&
        ((_k = pointsRange === null || pointsRange === void 0 ? void 0 : pointsRange.maximum_price) === null || _k === void 0 ? void 0 : _k.final_price) != null &&
        pointsRange.minimum_price.final_price === pointsRange.maximum_price.final_price
        ? pointsRange.minimum_price.final_price
        : null);
    /* -------- points formatting  -------- */
    const pointsValue = rawPointsValue != null ? formatPoints(rawPointsValue, locale) : null;
    const rawMinimumOldPointsPrice = ((_l = pointsRange === null || pointsRange === void 0 ? void 0 : pointsRange.minimum_price) === null || _l === void 0 ? void 0 : _l.regular_price) || 0;
    const rawMaximumOldPointsPrice = ((_m = pointsRange === null || pointsRange === void 0 ? void 0 : pointsRange.maximum_price) === null || _m === void 0 ? void 0 : _m.regular_price) || 0;
    const minimumOldPointsPrice = formatPoints(rawMinimumOldPointsPrice, locale);
    const maximumOldPointsPrice = formatPoints(rawMaximumOldPointsPrice, locale);
    const rawMinimumFinalPointsPrice = ((_o = pointsRange === null || pointsRange === void 0 ? void 0 : pointsRange.minimum_price) === null || _o === void 0 ? void 0 : _o.final_price) || 0;
    const rawMaximumFinalPointsPrice = ((_p = pointsRange === null || pointsRange === void 0 ? void 0 : pointsRange.maximum_price) === null || _p === void 0 ? void 0 : _p.final_price) || 0;
    const minimumFinalPointsPrice = formatPoints(rawMinimumFinalPointsPrice, locale);
    const maximumFinalPointsPrice = formatPoints(rawMaximumFinalPointsPrice, locale);
    return (React.createElement("div", { className: `product-prices ${className}` },
        shouldDisplayOldPrice && !showPoints && (React.createElement(React.Fragment, null,
            React.createElement("span", { "aria-hidden": "false", className: "sr-only" }, t('$common.$labels.originalPrice')),
            React.createElement("p", { className: "product-price old strike" }, prices.oldPrice),
            React.createElement("span", { "aria-hidden": "false", className: "sr-only" }, t('$common.$labels.price')))),
        !showPoints && prices.newPrice && React.createElement("p", { className: "product-price" }, prices.newPrice),
        showPoints && pointsValue && (React.createElement("p", { className: "product-price product-points" },
            pointsValue,
            " ",
            t('$common.$labels.points'),
            hasPointsDisclaimer ? '*' : '')),
        showPoints && shouldDisplayOldPoints && (React.createElement("p", { className: "product-price product-points old strike" },
            minimumOldPointsPrice,
            " - ",
            maximumOldPointsPrice,
            " ",
            t('$common.$labels.points'),
            hasPointsDisclaimer ? '*' : '')),
        showPoints && showPointsRange && (React.createElement("p", { className: "product-price product-points" },
            minimumFinalPointsPrice,
            " - ",
            maximumFinalPointsPrice,
            " ",
            t('$common.$labels.points'),
            hasPointsDisclaimer ? '*' : ''))));
};

export { Prices as P };
//# sourceMappingURL=Prices-RfqmCkHW.js.map
